<template>
<section id="services" class="page grid">

  <navigation-top/>

  <h1>SERVICES</h1>

  <article class="domaine code">

    <header>
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="standby servclick" v-on:click="footer('code')" width="120" viewBox="0 0 120 120">
      <defs>
        <linearGradient id="degs"><stop offset="0" stop-color="#262c43"/><stop offset="1" stop-color="#3d4765"/></linearGradient>
        <linearGradient xlink:href="#degs" id="bs" x1="10" y1="80" x2="110" y2="10" gradientUnits="userSpaceOnUse" />
        <linearGradient xlink:href="#degs" id="cs" x1="5" y1="95" x2="115" y2="85" gradientUnits="userSpaceOnUse" />
      </defs>
      <g class="services_line" stroke-linecap="round" stroke-linejoin="round" fill="none" opacity="0">
        <path class="stroke_y" d="M95 5l-60 105" stroke-width="4"/>
        <path class="stroke_p" d="M105 10l-55 95" stroke-width="6"/>
        <path class="stroke_g" d="M80 5l-60 105" stroke-width="10"/>
      </g>
      <path class="stroke_b" d="M15 22h90c3 0 5.013 2 5 5v65h-100v-65c0-3 2-5 5-5z" fill="url(#bs)" stroke-width="1.4" stroke-linecap="square" stroke-linejoin="round"/>
      <path class="stroke_b" d="M10 97h100c14.207 0-2.896 6-10 6h-80c-7.104 0-24.207-6-10-6z" fill="url(#cs)" stroke-width="1.4" stroke-linecap="square" stroke-linejoin="round"/>
      <g stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" fill="none">
        <path class="stroke_b" d="M10 28h100"/>
        <path class="stroke_p" d="M20 25h2"/>
        <path class="stroke_y" d="M25 25h2"/>
        <path class="stroke_g" d="M30 25h2"/>
        <path class="stroke_y" d="M53 100h14"/>
      </g>
      <g stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
        <path class="stroke_y code_closebar" d="M65 46l-10 26"/>
        <path class="stroke_g code_left_tag" d="M50 51l-10 8 10 8"/>
        <path class="stroke_g code_right_tag" d="M70 51l10 8-10 8"/>
      </g>
      </svg>

      <h2>SITE INTERNET</h2>

    </header>

    <ul>
      <li>Site vitrine</li>
      <li class="dark">Boutique e-commerce</li>
      <li>Site spécifique</li>
      <li class="dark">Refonte de site</li>
      <li>Applications web et mobile</li>
    </ul>

    <footer class="none">

      <svg xmlns="http://www.w3.org/2000/svg" height="16" class="arrowscroll" viewBox="0 0 320 512">
        <path fill="#fff" d="M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"/>
      </svg>

      <p class="paragh">
        Création de site web sur mesure, webdesign <strong>unique</strong> qui correspond à votre charte graphique. Intégration d'interface <strong>responsive</strong> et multiplateforme avec prise en compte des <strong>normes seo</strong>. Vente et payement en ligne avec liaison "https" <strong>chiffrées</strong>. Dévéloppement php ou javascript de <strong>module individuel</strong> selon des besoins particuliers. Refonte structurelle et graphique de site pour correspondre aux <strong>nouveaux critères</strong>. Possibilité d'application mobile avec <strong>API rest</strong> et <strong>cordova</strong>.
      </p>

      <span class="servclick" v-on:click="footer('code')">
      <svg xmlns="http://www.w3.org/2000/svg" height="14" class="fa_ico_close" viewBox="0 0 350 440">
          <path fill="#fff" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
        </svg>
        Fermer
      </span>

    </footer>

  </article>

  <article class="domaine visuel">

    <header>

      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="standby servclick" v-on:click="footer('visuel')" width="120" viewBox="0 0 120 120">
      <g class="services_line" stroke-linecap="round" stroke-linejoin="round" fill="none" opacity="0">
        <path class="stroke_y" d="M95 5l-60 105" stroke-width="4"/>
        <path class="stroke_p" d="M105 10l-55 95" stroke-width="6"/>
        <path class="stroke_g" d="M80 5l-60 105" stroke-width="10"/>
      </g>
      <path class="stroke_b" d="M15 22h90c3 0 5.013 2 5 5v65h-100v-65c0-3 2-5 5-5z" fill="url(#bs)" stroke-width="1.4" stroke-linecap="square" stroke-linejoin="round"/>
      <path class="stroke_b" d="M10 97h100c14.207 0-2.896 6-10 6h-80c-7.104 0-24.207-6-10-6z" fill="url(#cs)" stroke-width="1.4" stroke-linecap="square" stroke-linejoin="round"/>
      <g stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" fill="none">
        <path class="stroke_b" d="M10 28h100"/>
        <path class="stroke_p" d="M20 25h2"/>
        <path class="stroke_y" d="M25 25h2"/>
        <path class="stroke_g" d="M30 25h2"/>
        <path class="stroke_y" d="M53 100h14"/>
      </g>
      <g stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none">
        <circle class="stroke_y visuel_circleY" r="12" cy="53" cx="60"/>
        <circle class="stroke_g visuel_circleG" r="10" cy="68" cx="50"/>
        <circle class="stroke_g visuel_circleP" r="14" cy="65" cx="67"/>
      </g>
      </svg>

      <h2>IDENTITÉ VISUELLLE</h2>

    </header>

    <ul>
      <li>Charte graphique</li>
      <li class="dark">Logo et image de marque</li>
      <li>Webdesign et interface ux/ui</li>
      <li class="dark">Illustration et infographie</li>
      <li>Communication web ou Print</li>
    </ul>

    <footer class="none">

      <svg xmlns="http://www.w3.org/2000/svg" height="16" class="arrowscroll" viewBox="0 0 320 512">
        <path fill="#fff" d="M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"/>
      </svg>

      <p class="paragh">
        Réalisation d'identitée visuelle ou de support de communication pour le web ou l'impression. Choix entre <strong>plusieurs variantes</strong> à la conception et posibilité de faire des <strong>révisions</strong> sur celle-ci. Création d'interface web <strong>originale</strong> et de <strong>qualitée</strong> pour tout type de plateforme. Exemples de supports: affiche, flyer, plaquette, carte de visite, dépliant, brochure, bannière, autocollant. Livraison des fichiers sources <strong>haute résolution</strong> 300dpi (.jpg .png .svg .ai .eps .pdf)
      </p>

      <span class="servclick" v-on:click="footer('visuel')">
        <svg xmlns="http://www.w3.org/2000/svg" height="14" class="fa_ico_close" viewBox="0 0 350 440">
          <path fill="#fff" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
        </svg>
        Fermer
      </span>

    </footer>

  </article>

  <article class="domaine seo">

    <header>

      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="standby servclick" v-on:click="footer('seo')" width="120" viewBox="0 0 120 120">
      <g class="services_line" stroke-linecap="round" stroke-linejoin="round" fill="none" opacity="0">
      <path class="stroke_y" d="M95 5l-60 105" stroke-width="4"/>
      <path class="stroke_p" d="M105 10l-55 95" stroke-width="6"/>
      <path class="stroke_g" d="M80 5l-60 105" stroke-width="10"/>
      </g>
      <path d="M15 22h90c3 0 5.013 2 5 5v65h-100v-65c0-3 2-5 5-5z" fill="url(#bs)" stroke="#1f2435" stroke-width="1.4" stroke-linecap="square" stroke-linejoin="round"/>
      <path d="M10 97h100c14.207 0-2.896 6-10 6h-80c-7.104 0-24.207-6-10-6z" fill="url(#cs)" stroke="#1f2435" stroke-width="1.4" stroke-linecap="square" stroke-linejoin="round"/>
      <g stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" fill="none">
        <path class="stroke_b" d="M10 28h100"/>
        <path class="stroke_p" d="M20 25h2"/>
        <path class="stroke_y" d="M25 25h2"/>
        <path class="stroke_g" d="M30 25h2"/>
        <path class="stroke_y" d="M53 100h14"/>
      </g>
      <g class="stroke_y" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" fill="none">
        <path class="stroke_g seo_line" d="M35.342 69.004l7.205-7.205 3.602 3.602 21.614-21.614 7.205 7.205 10.807-10.807" stroke-width="2"/>
        <path d="M35.5 80v-5h7v5"/>
        <path d="M49.7 80v-10.8h7v10.8"/>
        <path d="M64 80v-25h7v25"/>
        <path d="M78.5 80v-21.6h7v21.6"/>
      <g class="seo_one" stroke-width="1.4">
        <path d="M44.708 48.831l2.882-2.882v7.205"/>
        <path d="M38.944 46.67v6.484"/>
        <path d="M35.997 46.67v6.484"/>
        <path d="M40.713 51.386h-6.484"/>
        <path d="M40.713 48.438h-6.484"/>
      </g>
      </g>
      </svg>

      <h2>STRATÉGIE SEO</h2>

    </header>

    <ul>
      <li>Référencement naturel</li>
      <li class="dark">Google my business</li>
      <li>Campagne adwords et keyplanner</li>
      <li class="dark">Outil moz et bilan analytics</li>
      <li>Réseaux sociaux (smo)</li>
    </ul>

    <footer class="none">

      <svg xmlns="http://www.w3.org/2000/svg" height="16" class="arrowscroll" viewBox="0 0 320 512">
        <path fill="#fff" d="M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"/>
      </svg>

      <p class="paragh">
        Amélioriation du traffic et de la <strong>visibilité</strong> de votre site internet. Modification du code hmtl pour répondre <strong>standard w3c</strong> actuel et faciliter la lecture de votre site par le <strong>robot google</strong>. Boost du reférencement locale avec <strong>Google My Business</strong> pour passer devant vos concurents dans les résultats. Ciblage de <strong>profils clients</strong> afin de déterminer les mot-clefs à valorisés. Suivis du <strong>traffic web</strong> et visualisation des <strong>statistiques mensuelles</strong>. Conseil en gestion de vos différents <strong>réseaux sociaux</strong> et organisation de campagne publicitaire.
      </p>

      <span class="servclick" v-on:click="footer('seo')">
        <svg xmlns="http://www.w3.org/2000/svg" height="14" class="fa_ico_close" viewBox="0 0 350 440">
          <path fill="#fff" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
        </svg>
        Fermer
      </span>

    </footer>

  </article>

  <article class="domaine support">

    <header>

      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="standby servclick" v-on:click="footer('support')" width="120" viewBox="0 0 120 120">
      <g class="services_line" stroke-linecap="round" stroke-linejoin="round" fill="none" opacity="0">
        <path class="stroke_y" d="M95 5l-60 105" stroke-width="4"/>
        <path class="stroke_p" d="M105 10l-55 95" stroke-width="6"/>
        <path class="stroke_g" d="M80 5l-60 105" stroke-width="10"/>
      </g>
      <path d="M15 22h90c3 0 5.013 2 5 5v65h-100v-65c0-3 2-5 5-5z" fill="url(#bs)" stroke="#1f2435" stroke-width="1.4" stroke-linecap="square" stroke-linejoin="round"/>
      <path d="M10 97h100c14.207 0-2.896 6-10 6h-80c-7.104 0-24.207-6-10-6z" fill="url(#cs)" stroke="#1f2435" stroke-width="1.4" stroke-linecap="square" stroke-linejoin="round"/>
      <g stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" fill="none">
        <path class="stroke_b" d="M10 28h100"/>
        <path class="stroke_p" d="M20 25h2"/>
        <path class="stroke_y" d="M25 25h2"/>
        <path class="stroke_g" d="M30 25h2"/>
        <path class="stroke_y" d="M53 100h14"/>
      </g>
      <g stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" fill="none">
        <path class="stroke_y support_serv" d="M90 79v-18h-60v18z"/>
        <path class="stroke_y support_serv" d="M90 54v-12h-60v12z"/>
        <path d="M53 68h32" class="stroke_g support_line"/>
        <path d="M85 48h-15" class="stroke_y support_line"/>
        <path d="M53 48h11" class="stroke_g support_line"/>
        <path d="M40 74h45" class="stroke_y support_line"/>
      </g>
      <g stroke-linecap="round" stroke-linejoin="round" fill="none">
        <circle class="stroke_y support_circle" cx="36.7" cy="48" r="2.6" stroke-width="1.4"/>
        <circle class="stroke_g support_circle"  cy="68" cx="36.7" r="2.6" stroke-width="1.4" />
        <circle class="stroke_y support_circle" r="2" cx="46" cy="68" stroke-width="1.2"/>
        <circle class="stroke_g support_circle" cy="48" cx="46" r="2" stroke-width="1.2"/>
      </g>
      </svg>

      <h2>STRUCTURE & SUIVIS</h2>

    </header>

    <ul>
      <li>Hébergement et domaine</li>
      <li class="dark">Maintenance de site</li>
      <li>Ajout de contenus</li>
      <li class="dark">Formation web</li>
      <li>Emailing</li>
    </ul>

    <footer class="none">

      <svg xmlns="http://www.w3.org/2000/svg" height="16" class="arrowscroll" viewBox="0 0 320 512">
        <path fill="#fff" d="M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"/>
      </svg>

      <p class="paragh">
        Accompagnement de la mise en ligne de votre projet, prise en charge de la location du <strong>serveur web</strong> et du <strong> nom de domaine</strong>, maintenance, sauvegarde et <strong>mise à jours</strong> et votre site (sécurité supplémentaire <strong>contre le piratage</strong>). Forfait d'ajout de contenus mensuel, photos ou articles. <strong>Formation</strong> à la prise en main de l'interface d'administration, création et gestion du contenus, selon le CMS utilisé ou le <strong>back-office</strong> s'il sagit d'un projet spécifique. Service d'emailing pour renforcer la communication et la <strong>relation client</strong>, newsletters personnalisés, événementiels.
      </p>

      <span class="servclick" v-on:click="footer('support')">
        <svg xmlns="http://www.w3.org/2000/svg" height="14" class="fa_ico_close" viewBox="0 0 350 440">
          <path fill="#fff" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
        </svg>
        Fermer
      </span>

    </footer>

  </article>

</section>
</template>

<script>
import {meta} from '../meta'
import NavigationTop from '@/components/Template_Navigation_Top'

export default {
  name: 'services',
  components: {
    'navigation-top': NavigationTop
  },
  data () {
    return {
    }
  },
  beforeCreate () {
    var metaTitle = 'Services et prestations'
    var metaDesc = 'Détails des services et prestations proposés par kévin le saout, dévéloppement de site internet, infographie et illustration sur mesure, référencement au cas par cas, hébergement et maintenance de serveur.'
    meta(metaTitle, metaDesc)
  },
  mounted () {
    // service code :hover class
    var code = document.querySelector('.code svg')
    code.addEventListener('mouseover', function () {
      if (!code.classList.contains('open')) {
        code.classList.add('open')
        code.classList.remove('standby')
      }
    }, false)
    code.addEventListener('mouseleave', function () {
      if (code.classList.contains('open')) {
        code.classList.remove('open')
        code.classList.add('standby')
      }
    }, false)

    // service visuel :hover class
    var visuel = document.querySelector('.visuel svg')
    visuel.addEventListener('mouseover', function () {
      if (!visuel.classList.contains('open')) {
        visuel.classList.add('open')
        visuel.classList.remove('standby')
      }
    }, false)
    visuel.addEventListener('mouseleave', function () {
      if (visuel.classList.contains('open')) {
        visuel.classList.remove('open')
        visuel.classList.add('standby')
      }
    }, false)

    // service seo :hover class
    var seo = document.querySelector('.seo svg')
    seo.addEventListener('mouseover', function () {
      if (!seo.classList.contains('open')) {
        seo.classList.add('open')
        seo.classList.remove('standby')
      }
    }, false)
    seo.addEventListener('mouseleave', function () {
      if (seo.classList.contains('open')) {
        seo.classList.remove('open')
        seo.classList.add('standby')
      }
    }, false)

    // service support :hover class
    var support = document.querySelector('.support svg')
    support.addEventListener('mouseover', function () {
      if (!support.classList.contains('open')) {
        support.classList.add('open')
        support.classList.remove('standby')
      }
    }, false)
    support.addEventListener('mouseleave', function () {
      if (support.classList.contains('open')) {
        support.classList.remove('open')
        support.classList.add('standby')
      }
    }, false)
  },
  methods: {
    footer (el) {
      var footer = document.querySelector('.' + el + ' footer')
      var top = document.querySelector('.' + el + ' h2')
      var reset = document.querySelector('.' + el)
      if (footer.classList.contains('serviceIn')) {
        footer.classList.add('serviceOut')
        footer.classList.remove('serviceIn')
        this.scrollMeTo(reset)
        setTimeout(function () {
          footer.classList.add('none')
        }, 500)
      } else {
        this.scrollMeTo(top)
        setTimeout(function () {
          footer.classList.add('serviceIn')
          footer.classList.remove('serviceOut')
          footer.classList.remove('none')
        }, 400)
      }
    },
    scrollMeTo (el) {
      var start = window.pageYOffset
      var destination = el.offsetTop
      var destinationOffset = destination - start
      const scroll = (pos) => {
        var i = pos || start
        // check if scroll Up or Down
        if (Math.sign(destinationOffset) === -1) {
          if (i > destination) {
            setTimeout(() => {
              window.scrollTo(0, i)
              scroll(i - 5)
            }, 5)
          }
        } else {
          if (i < destination) {
            setTimeout(() => {
              window.scrollTo(0, i)
              scroll(i + 5)
            }, 5)
          }
        }
      }
      scroll()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page_Services.vue